/**
 * This class is used with ExploreArea widget
 */
async function initExploreAreaMapV2() {
    var exploreAreaMap = document.getElementById('explore-area-map');
    if (exploreAreaMap == null) {
        return;
    }

    var hiddenExploreAreaLat = $("#hiddenExploreAreaLat").val();
    var hiddenExploreAreaLong = $("#hiddenExploreAreaLong").val();
    if (IS_LOCALHOST === true) {
        var hiddenExploreAreaLat = 33.596891;
        var hiddenExploreAreaLong = -117.658156;
    }

    // Use DYNAMIC LOADING for Google Maps - https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
    const { Map } = await  google.maps.importLibrary('maps');

    var map = new Map(exploreAreaMap, {
        center: new google.maps.LatLng(hiddenExploreAreaLat, hiddenExploreAreaLong),
        zoom: 16,
        styles: [
            {elementType: 'geometry', stylers: [{saturation: '-75'}]},
            {featureType: 'road',elementType: 'geometry',stylers: [{saturation: '-75'}]},
            {featureType: 'road',elementType: 'geometry.stroke',stylers: [{saturation: '-75'},{color: '#c9c1a9'}]},
            {featureType: 'road.highway',elementType: 'geometry',stylers: [{saturation: '-75'}]},
            {featureType: 'road.highway',elementType: 'geometry.stroke',stylers: [{saturation: '-75'},{color: '#c9c1a9'}]},
            {featureType: 'transit',elementType: 'geometry',stylers: [{saturation: '-75'}]},
        ]
    });

    //declare variables for the checkboxes found in explore the area
    var schoolInput = $('input[name=school-filter]');
    var businessInput = $('input[name=business-filter]');
    var shoppingInput = $('input[name=shopping-filter]')
    var medicalInput = $('input[name=medical-filter]');
    var parkInput = $('input[name=park-filter]');
    var publicInput = $('input[name=public-filter]');
    var worshipInput = $('input[name=worship-filter]');
    var attractionInput = $('input[name=attraction-filter]');

    //detect click events on the checkboxes
    $(businessInput).add(parkInput)
        .add(schoolInput).add(publicInput)
        .add(shoppingInput).add(worshipInput)
        .add(medicalInput).add(attractionInput).click(function () {

            //updates the default styles based on the condition of the checkbox
            var styles = {
                reset: [
                    {
                        "featureType": "poi.school", //declares POI type
                        "elementType": "labels.icon", //affects only the labels and icons of POI type
                        "stylers": [{ "visibility": schoolInput.is(':checked') ? 'on' : 'off' }] //if checkbox is off, adds visiblity styler
                    },
                    {
                        "featureType": "poi.business.food_and_drink",
                        "elementType": "labels.icon",
                        "stylers": [{ "visibility": businessInput.is(':checked') ? 'on' : 'off' }]
                    },
                    {
                        "featureType": "poi.business.shopping",
                        "elementType": "labels.icon",
                        "stylers": [{ "visibility": shoppingInput.is(':checked') ? 'on' : 'off' }]
                    },
                    {
                        "featureType": "poi.attraction",
                        "elementType": "labels.icon",
                        "stylers": [{ "visibility": parkInput.is(':checked') ? 'on' : 'off' }]
                    },
                    {
                        "featureType": "poi.medical",
                        "elementType": "labels.icon",
                        "stylers": [{ "visibility": medicalInput.is(':checked') ? 'on' : 'off' }]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.icon",
                        "stylers": [{ "visibility": parkInput.is(':checked') ? 'on' : 'off' }]
                    },
                    {
                        "featureType": "poi.government",
                        "elementType": "labels.icon",
                        "stylers": [{ "visibility": publicInput.is(':checked') ? 'on' : 'off' }]
                    },
                    {
                        "featureType": "poi.place_of_worship",
                        "elementType": "labels.icon",
                        "stylers": [{ "visibility": worshipInput.is(':checked') ? 'on' : 'off' }]
                    }
                ]
            }
            map.setOptions({ styles: styles['reset'] });//runs the map style
        });
    //Used to destroy preset infobox. Interval runs until it hits the gmstyle
    new map.addListener('click', function (event) {
        if (event.placeId) {
            var interval = setInterval(function () {
                var item = $('div.gm-style-iw').prev();
                var gmStyle = "div.gm-style-iw";
                if (item.length) {
                    $(gmStyle).prev().css("display", "none"); //removes style for sibling that shows the default styles
                    $(gmStyle).closest('div').next().find('img').css("display", "none"); //removes close button image
                    $(gmStyle).next().addClass("gw-close"); //creates class for new close button class
                    clearInterval(interval);
                }
            }, 1);
        }
    });

    var host = "//" + window.location.host;
    //trilogy communities icon
    if ($('body').hasClass('trilogy')) {
        var exploreIcon = host + '/patternlibrary/dist/assets/img/maps/community-pin-tril.png';
        if (IS_LOCALHOST === true) {
            exploreIcon = host + '/assets/img/maps/community-pin-tril.png';
        }

    }
    //default communities icon
    else {
        var exploreIcon = host + '/patternlibrary/dist/assets/img/maps/community-pin.png';
        if (IS_LOCALHOST === true) {
            exploreIcon = host + '/assets/img/maps/community-pin.png';
        }

    }
    // Markers array (title, lat, long, label)
    var commnuitiesNearByTitle = $("#commnuitiesNearByTitle").val();
    var commnuitiesNearByLat = $("#commnuitiesNearByLat").val();
    var commnuitiesNearByLong = $("#commnuitiesNearByLong").val();
    var commnuitiesNearByLabel = $("#commnuitiesNearByLabel").val();
    var communitiesNearBy = [
        [commnuitiesNearByTitle, commnuitiesNearByLat, commnuitiesNearByLong, commnuitiesNearByLabel],
    ];
    // Local variables for testing
    if (IS_LOCALHOST === true) {
        var communitiesNearBy = [
            ['Com1', 33.59904, -117.66004, 'Vistancia'],
            ['Com2', 33.599596, -117.662436, 'Eclipse'],
            ['Com3', 33.597624, -117.655646, 'Timbergrove']
        ];
    }

    // Create markers only for elements that are not null
    communitiesNearBy.forEach(function (community) {
        if (community[0] != null
            && community[1] != null
            && community[2] != null
            && community[3] != null) {
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(community[1], community[2]),
                icon: {
                    url: exploreIcon,
                    labelOrigin: new google.maps.Point(15, -15)
                },
                map: map,
                label: {
                    text: community[3],
                    color: '#3E738E',
                    fontSize: '14px',
                    fontWeight: 'bold'
                }
            });
        } 
    });

    //Due to google map API constraints on the label, this method was used to add a class value
    new google.maps.event.addListenerOnce(map, 'tilesloaded', exploreAreaFindLabel);
    function exploreAreaFindLabel() {
        //finds the div with below inline styles and adds class marker labels
        $('div[style="color: transparent; font-size: 14px; font-weight: bold; font-family: Roboto, Arial, sans-serif;"]').addClass("marker-labels");
    }

};

window.initExploreAreaMapV2 = initExploreAreaMapV2;